export const iconFontAwesomePhotosImagesClone = (
	<i className="fa-solid fa-clone"></i>
);
